import { useState } from "react";
import classnames from "classnames";

const OtpFilter = (props) => {
  const { value, options, onFilterChange } = props;
  const [isActive, setActive] = useState(value);

  function onToggleClick() {
    if (isActive) {
      setActive(false);
      onFilterChange("isOtp", options[0]);
    } else {
      setActive(true);
      onFilterChange("isOtp", options[1]);
    }
  }

  const filterClassName = classnames("filter-otp filter-select-wrapper", {
    active: isActive,
  });

  return (
    <div className={filterClassName} onClick={() => onToggleClick()}>
      <span> OTP </span>
    </div>
  );
};

export default OtpFilter;
